export default "__VITE_ASSET__28df7e56__"